module.exports = __webpack_public_path__ + "assets/img/thumb_template_padrao.7505ea85.svg";